define.alias("shared/components/shared/ui/accordion", "preview-grid/components/shared/ui/accordion");